<div class="modal">
    <!-- SIGNUP PROCESSING -->
    <div class="header">
        <div class="smash-logo">
            <i class="icon-smash_icologo_chip"></i>
        </div>
        <ng-container
            *ngIf="(updateAccountProcessing$ | async) || (updateBillingInformationsProcessing$ | async) || (updateSubscriptionProcessing$ | async)">
            <h1>{{ 'MODAL_SIGNUP_CREATION' | translate }}</h1>
        </ng-container>
        <ng-container *ngIf="(paymentProcessing$ | async)">
            <h1>{{ 'MODAL_SIGNUP_PROCESSING_PAYMENT' | translate }}</h1>
        </ng-container>
        <ng-container *ngIf="(signupSucceed$ | async)">
            <ng-container *ngIf="(paymentSucceed$ | async)">
                <h1>{{ 'MODAL_SIGNUP_SUCCESS_PAYMENT_TITLE' | translate }}</h1>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="(updateAccountFailed$ | async)">
            <h1>{{ 'MODAL_SIGNUP_FAIL_ACCOUNT_CREATION' | translate }}</h1>
        </ng-container>
        <ng-container *ngIf="(updateBillingInformationsFailed$ | async)">
            <h1>{{ 'MODAL_SIGNUP_FAIL_UPDATE_BILLING_INFORMATIONS' | translate }}</h1>
        </ng-container>
        <ng-container *ngIf="(updateSubscriptionFailed$ | async)">
            <h1>{{ 'MODAL_SIGNUP_FAIL_PAYMENT_TITLE' | translate }}</h1>
        </ng-container>
        <ng-container *ngIf="(paymentFailed$ | async)">
            <h1>{{ 'MODAL_SIGNUP_FAIL_PAYMENT_TITLE' | translate }}</h1>
        </ng-container>
    </div>
    <div class="body">
        <ng-container *ngIf="(signupProcessing$ | async)">
            <div class="loading-spinner-container">
                <div class="loading-spinner-grey"></div>
            </div>
        </ng-container>
        <!-- UPDATE BILLING INFORMATIONS FAILED -->
        <ng-container *ngIf="(updateBillingInformationsFailed$ | async)">
            <p *ngIf="(updateBillingInformationsError$ | async) === 'vatNumber'">{{ 'MODAL_SIGNUP_WRONG_VATNUMBER' | translate }}</p>
        </ng-container>
        <!-- PAYMENT FAILED -->
        <ng-container *ngIf="(paymentFailed$ | async)">
            <p>{{ 'MODAL_SIGNUP_FAIL_PAYMENT_TEXT' | translate }}</p>
        </ng-container>
        <ng-container *ngIf="(updateSubscriptionFailed$ | async)">
            <p>{{ 'MODAL_SIGNUP_FAIL_ACCOUNT_CREATION' | translate }}</p>
        </ng-container>
        <ng-container *ngIf="(updateAccountFailed$ | async)">
            <p>{{ 'SIGNUP_EMAIL_ALREADY_USE' | translate }}</p>
        </ng-container>
    </div>
    <div class="footer" *ngIf="!(signupProcessing$ | async) && !(signupSucceed$ | async)">
        <button class="btn-new red" (click)="retrySignup()">{{ 'MODAL_SIGNUP_ERROR_BUTTON' | translate }} </button>
    </div>
</div>